import React, { useEffect, useState } from 'react';
import { Form, Field } from 'react-final-form';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useSelector, useDispatch } from "react-redux";
import { classNames } from 'primereact/utils';
import { UpdatePassword } from 'services/user/user.service';

import './FormDemo.css';

export const ChangePassword = () => {
    const [showMessage, setShowMessage] = useState(false);
    const [formData, setFormData] = useState({});

    const { updatePassword, updatePasswordLoading, updatePasswordError } = useSelector((state) => state.updatePassword);

    const dispatch = useDispatch();


    const validate = (data) => {
        let errors = {};

        if (!data.old_password) {
            errors.old_password = 'Old password is required.';
        }
        if (!data.new_password) {
            errors.new_password = 'New password is required.';
        }

        return errors;
    };

    const onSubmit = async (data, form) => {
        await dispatch(UpdatePassword(data)).then(() => {
            return
        });
        form.restart();
    };

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };



    return (
        <div className="form-demo">

            <div className="flex justify-content-center">
                <div className="card">
                    <h5 className="text-center">Update Password</h5>
                    <Form onSubmit={onSubmit} initialValues={{ old_password: '', new_password: ''}} validate={validate} render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit} className="p-fluid">
                            <Field name="old_password" render={({ input, meta }) => (
                                <div className="field">
                                    <span className="p-float-label">
                                        <Password id="old_password" {...input} toggleMask className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                        <label htmlFor="old_password" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Old Password*</label>
                                    </span>
                                    {getFormErrorMessage(meta)}
                                </div>
                            )} />

                            <Field name="new_password" render={({ input, meta }) => (
                                <div className="field">
                                    <span className="p-float-label">
                                        <Password id="new_password" {...input} toggleMask className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                        <label htmlFor="new_password" className={classNames({ 'p-error': isFormFieldValid(meta) })}>New Password*</label>
                                    </span>
                                    {getFormErrorMessage(meta)}
                                </div>
                            )} />
                            <p style={{textAlign: 'center', color: 'green'}}>{updatePassword == 'Password updated successfully.' ? updatePassword : ''}</p>
                            <Button type="submit" label="Update Password" className="mt-2" />
                        </form>
                    )} />
                </div>
            </div>
        </div>
    );
}
                 